module.exports = __webpack_public_path__ + "static/media/citriagro.d89ab213.webp";